import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/students/StudentsAction";
import { DropdownOptions, redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import "../../../../../../_metronic/_assets/sass/pages/wizard/wizard-4.scss";
import KTWizard from "../../../../../../_metronic/_assets/js/components/wizard";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { StudentEditForm } from "./StudentEditForm";

export function StudentEdit({
  history,
  match: {
    params: { page, term, id }
  }
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, familyMembers, sections, student } = useSelector(
    (state) => ({
      actionsLoading: state.students.actionsLoading,
      isSuccess: state.students.isSuccess,
      type: state.students.type,
      familyMembers: state.students.familyMembers,
      sections: state.students.sections,
      student: state.students.student
    }),
    shallowEqual
  );
  const sectionOptions = DropdownOptions.concat(sections);

  useEffect(() => {
    if (page === "kesin-kayit-yap") dispatch(actions.getUnregisteredStudent(id));
    if (page === "kesin-kayit") dispatch(actions.getStudentInPreInterview(id));
    else dispatch(actions.getStudent(page, term, id));
    return () => dispatch(actions.cleanStudentsState());
  }, [page, term, id, dispatch]);
  
  useEffect(() => {
    let _title = "Öğrenci";
    let action = page === "kayit-yenile" ? "Kayıt Yenile" : page === "kesin-kayit-yap" || page === "kesin-kayit" || page === "ekle" ? "Ekle" : page === "duzenle" ? "Düzenle" : "";
    _title += " " + action;
    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  // Belli Bir Aile Bireyi Listesini Elde Eder
  const getFamilyMembers = (param) => {
    dispatch(actions.getFamilyMembers(param));
  }
  
  // Belli Bir Sınıfa Ait Şubeleri Elde Eder
  const getSections = (grade) => {
    dispatch(actions.getSections(grade));
  }

  // Belli Bir Aile Bireyini Elde Eder
  const getFamilyMember = (id) => {
    return dispatch(actions.getFamilyMember(id));
  }

  // Belli Bir Öğrenciyi Kaydeder
  const saveStudent = (formData) => {
    dispatch(actions.saveStudent(formData)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/ogrenciler"), 2500);
  };

  const btnRef = useRef();  
  const saveStudentClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  // Student Form Wizard
  const options = {
    startStep: 1,
    clickableSteps: true
  };

  new KTWizard(document.querySelector("#student_form_wizard"), options);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">
          <StudentEditForm
            familyMembers={familyMembers}
            sections={sectionOptions}
            student={student}
            btnRef={btnRef}
            getFamilyMembers={getFamilyMembers}
            getSections={getSections}
            getFamilyMember={getFamilyMember}
            saveStudent={saveStudent}
          />
        </div>      
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveStudentClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}